<template>
  <!--<div>-->
  <div class="partnersMain">
    <!--banner+导航-->
    <div class="bannerBox">
      <img ref="homeBanner" src="../../../assets/img/applyBanner.jpg" />
      <div class="topTextBox">
        <!--导航-->
        <top-nav></top-nav>
        <!--<top-nav :nav-index1="6"></top-nav>-->
      </div>
    </div>
    <div class="applyContent">
      <div class="contentW">
        <div class="applyLeftBox">
          <!-- <div class="text1">Our Offices</div>
          <div class="text2">Sydney</div>
          <div class="text3">
            <p>Sydney Suite 2304, Level 23, 66 Goulburn St,Sydney NSW 2000</p>
            <p>Phone: 1300 066 006</p>
          </div>

          <div class="text1"></div>
          <div class="text2">Melbourne</div>
          <div class="text3">
            <p>201, Level 2b 818 Whitehorse Rd Box Hill, VIC 3128</p>
            <p>Phone: 1300 066 006</p>
          </div>

          <div class="text1"></div>
          <div class="text2">Adelaide</div>
          <div class="text3">
            <p>177 Gilbert street, Adelaide, SA 5000</p>
            <p>Phone: 1300 066 006</p>
          </div>

          <div class="text1"></div>
          <div class="text2">Shanghai</div>
          <div class="text3">
            <p>
              Shanghai Room 505, Building 2, Dongfang Shangbo Creative
              Industrial Park, 3539 Dongfang Road, Pudong New District, Shanghai
            </p>
            <p>Phone: ++86 13917310169</p>
          </div> -->

          <div class="text1">Contact Us</div>
          <!-- <div class="text2">Contact us</div> -->
          <br/>
          <div class="text3">
            <p>Phone: 1300 066 006</p>
            <p>info@supaytechnology.com</p>
            <p>WeChat customer service: superpay2017</p>
          </div>

          <div class="imgBox">
            <p>微信小客服:</p>
            <img src="../../../assets/img/customWx.jpg" width="50%"/>
          </div>
          <div class="imgBox">
            <p >微信公众号:</p><br/>
            <img src="../../../assets/img/wemImg2.png"/>
          </div>
        </div>

        <div class="applyRightBox">
          <div class="titles">Fill in the Application Form and Submit</div>
          <form action method="get">
            <div class="inputBox">
              <div class="titleText">
                YOUR NAME:
                <span>*</span>
              </div>
              <div class="inputDiv">
                <input
                  type="text"
                  class="inputs"
                  v-model="datas.nameVal"
                  placeholder
                  v-on:keyup="nameUp"
                />
              </div>
              <div class="tipBox" v-show="keys.nameKey">
                Please enter your name
              </div>
            </div>

            <div class="inputBox">
              <div class="titleText">
                YOUR EMAIL:
                <span>*</span>
              </div>
              <div class="inputDiv">
                <input
                  type="text"
                  class="inputs"
                  v-model="datas.emailVal"
                  placeholder
                  v-on:keyup="emailUp"
                />
              </div>
              <div class="tipBox" v-show="keys.emailKey">
                Please enter your email
              </div>
            </div>

            <div class="inputBox">
              <div class="titleText">YOUR PHONE NUMBER:</div>
              <div class="inputDiv">
                <input
                  type="text"
                  class="inputs"
                  v-model="datas.numberVal"
                  placeholder
                />
              </div>
            </div>

            <div class="inputBox">
              <div class="titleText">
                STORE/COMPANY NAME:
                <span>*</span>
              </div>
              <div class="inputDiv">
                <input
                  type="text"
                  class="inputs"
                  v-model="datas.companyVal"
                  placeholder
                  v-on:keyup="companylUp"
                />
              </div>
              <div class="tipBox" v-show="keys.companyKey">
                Please enter your store/company name
              </div>
            </div>

            <div class="inputBox">
              <div class="titleText">
                STORE ADDRESS:
                <span>*</span>
              </div>
              <div class="inputDiv">
                <input
                  type="text"
                  class="inputs"
                  v-model="datas.addressVal"
                  placeholder
                  v-on:keyup="addressUp"
                />
              </div>
              <div class="tipBox" v-show="keys.addressKey">
                Please enter your store address
              </div>
            </div>

            <div class="inputBox" @mouseleave="leave()">
              <div class="titleText">
                SERVICE REQUIRED:
                <span>*</span>
              </div>
              <div class="inputDiv">
                <div class="select">
                  <div class="inner">
                    <div class="inputWrapper inputDiv" @click="selectClick()">
                      <input
                        type="text"
                        class="inputs selectInput"
                        readonly
                        placeholder
                        v-model="datas.requiedVal"
                      />
                      <div class="selectIcon">
                        <img
                          v-show="!showOptions"
                          src="../../../assets/icon/selectIcon.png"
                        />
                        <img
                          v-show="showOptions"
                          src="../../../assets/icon/selectIcon1.png"
                        />
                      </div>
                    </div>
                    <ul class="options" v-show="showOptions">
                      <li
                        v-for="(item, index) in options"
                        :class="item.key === selKey ? 'act' : ''"
                        :key="index"
                        @click="choose(item.key, item.value)"
                      >
                        {{ item.value }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="tipBox" v-show="keys.requiedKey">
                Please enter your service required
              </div>
            </div>

            <div class="textAreaBox">
              <div class="titleText">YOUR MESSAGE</div>
              <div class="textAreaDiv">
                <textarea
                  class="textAreas"
                  v-model="datas.messageVal"
                ></textarea>
              </div>
            </div>

            <div class="btnBox">
              <button type="button" class="submitBtn" @click="submitBtn">
                SUBMIT
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!--底部-->
    <Footer></Footer>

    <div class="alertBox" v-show="errorIndex" @click="errorIndex = false">
      <div class="alertText">Please check the required fields</div>
    </div>

    <div class="alertBox" v-show="successIndex" @click="successIndex = false">
      <div class="alertText">Submitted successfully</div>
    </div>
  </div>
  <!--</div>-->
</template>

<script>
import topNav from "./nav";
import axios from "axios";
import Footer from "@/components/Footer"
let timer = null; //定义初始值
export default {
  name: "apply",
  components: { topNav,Footer },
  props: {
    step: {
      //此数据是控制动画快慢的
      type: Number,
      default: 50,
    },
  },
  data() {
    return {
      options: [
        {
          key: 1,
          value: "Alipay and WeChat Pay in-store service",
        },
        {
          key: 2,
          value: "Alipay and WeChat Pay online service",
        },
        {
          key: 3,
          value: "SuperiorPay marketing service",
        },
        {
          key: 4,
          value: "Other",
        },
      ],
      showOptions: false,
      selKey: 0,
      errorIndex: false,
      successIndex: false,

      datas: {
        nameVal: "",
        emailVal: "",
        numberVal: "",
        companyVal: "",
        addressVal: "",
        requiedVal: "",
        messageVal: "",
      },
      keys: {
        nameKey: 0,
        emailKey: 0,
        numberKey: 0,
        companyKey: 0,
        addressKey: 0,
        requiedKey: 0,
        messageKey: 0,
      },
    };
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
  mounted() {
    document.documentElement.scrollTop = 0;
  },
  methods: {
    //监听name输入
    nameUp: function (e) {
      // console.log(e.target.value);
      this.datas.nameVal = e.target.value;
      if (e.target.value.trim().length > 0) {
        this.keys.nameKey = 0;
      }
    },
    navClick2(url) {
      this.$router.push(url);
    },
    //监听邮箱输入
    emailUp: function (e) {
      // console.log(e.target.value);
      this.datas.emailVal = e.target.value;
      if (e.target.value.trim().length > 0) {
        this.keys.emailKey = 0;
      }
    },
    companylUp: function (e) {
      // console.log(e.target.value);
      this.datas.companylVal = e.target.value;
      if (e.target.value.trim().length > 0) {
        this.keys.companyKey = 0;
      }
    },
    addressUp: function (e) {
      // console.log(e.target.value);
      this.datas.addressVal = e.target.value;
      if (e.target.value.trim().length > 0) {
        this.keys.addressKey = 0;
      }
    },

    selectClick() {
      this.showOptions = true;
    },
    //提交
    submitBtn() {
      let _this = this;

      if (_this.datas.nameVal.trim().length <= 0) {
        _this.keys.nameKey = 1;
      }
      if (_this.datas.emailVal.trim().length <= 0) {
        _this.keys.emailKey = 1;
      }
      if (_this.datas.companyVal.trim().length <= 0) {
        _this.keys.companyKey = 1;
      }
      if (_this.datas.addressVal.trim().length <= 0) {
        _this.keys.addressKey = 1;
      }
      if (_this.datas.requiedVal.trim().length <= 0) {
        _this.keys.requiedKey = 1;
      }

      if (
        _this.keys.nameKey === 0 &&
        _this.keys.emailKey === 0 &&
        _this.keys.companyKey === 0 &&
        _this.keys.addressKey === 0 &&
        _this.keys.requiedKey === 0
      ) {
        _this.successIndex = true;
        axios
          .post("https://api.supaytechnology.com/email/email.php", {
            nameVal: _this.datas.nameVal,
            emailVal: _this.datas.emailVal,
            numberVal: _this.datas.numberVal,
            companyVal: _this.datas.companyVal,
            addressVal: _this.datas.addressVal,
            requiedVal: _this.datas.requiedVal,
            messageVal: _this.datas.messageVal,
          })
          .then(function (response) {
            console.log(response);
          })
          .catch(function (error) {
            console.log(error);
          });
        // axios
        //   .post("/", {
        //     nameVal: _this.datas.nameVal,
        //     emailVal: _this.datas.emailVal,
        //     numberVal: _this.datas.numberVal,
        //     companyVal: _this.datas.companyVal,
        //     addressVal: _this.datas.addressVal,
        //     requiedVal: _this.datas.requiedVal,
        //     messageVal: _this.datas.messageVal
        //   })
        //   .then(function(response) {
        //     console.log(response);
        //   })
        //   .catch(function(error) {
        //     console.log(error);
        //   });
        setTimeout(function () {
          _this.successIndex = false;
        }, 2000);
      } else {
        _this.errorIndex = true;
        setTimeout(function () {
          _this.errorIndex = false;
        }, 2000);
      }
    },

    //鼠标移出select
    leave() {
      this.showOptions = false;
      if (this.datas.requiedVal.length > 0) {
        this.keys.requiedKey = 0;
      }
    },
    //select选择
    choose(k, value) {
      this.showOptions = false;
      if (value !== this.datas.requiedVal) {
        this.datas.requiedVal = value;
        this.selKey = k;
      }
      if (this.datas.requiedVal.length > 0) {
        this.keys.requiedKey = 0;
      }
    },
    //置顶
    toTop() {
      // 动画

      timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        // this.isTop = true
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  },
};
</script>

<style scoped>
body {
  min-width: 1345px;
}

.alertBox {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.alertBox .alertText {
  padding: 0 15px;
  height: 3rem;
  line-height: 3rem;
  text-align: center;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  align-items: center;
  margin: auto;
  font-size: 1.25rem;
}

.partnersMain {
  width: 100%;
  height: auto;
}
.partnersMain .bannerBox {
  width: 100%;
  height: auto;
  position: relative;
}
.partnersMain .bannerBox > img {
  width: 100%;
}
.partnersMain .bannerBox .topTextBox {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

/*内容部分*/
.applyContent {
  width: 100%;
  height: auto;
  padding: 0rem;
  background-color: #fff;
  margin-top: -3px;
  overflow: hidden;
}

/*模块1（左侧内容）*/
.applyLeftBox {
  width: 27%;
  height: auto;
  float: left;
  min-height: 15rem;
  padding: 8rem 0;
}
.applyLeftBox .text1 {
  width: 100%;
  line-height: 4rem;
  font-size: 1.5rem;
  font-family: Montserrat300;
  color: #000;
  border-bottom: 1px solid #979797;
}
.applyLeftBox .text2 {
  width: 100%;
  height: 3rem;
  line-height: 3rem;
  font-size: 1rem;
  font-family: MontserratMedium;
  color: #000;
  margin-top: 1rem;
}
.applyLeftBox .text3 {
  width: 100%;
  height: auto;
  line-height: 1.2rem;
  font-size: 0.875rem;
  font-family: Montserrat300;
  color: #000;
  padding-bottom: 1.7rem;
}
.applyLeftBox .text3 > p {
  margin-bottom: 0.5rem;
  margin-top: 0.2rem;
}
.applyLeftBox .imgBox {
  width: 100%;
  height: auto;
  font-size: 0.875rem;
}
.applyLeftBox .imgBox > img {
  max-width: 100%;
  /* width: 135px; */
}

/*模块2（右侧内容）*/
.applyRightBox {
  width: 65%;
  height: auto;
  float: right;
  min-height: 15rem;
  padding: 8rem 0;
}
.applyRightBox .titles {
  font-size: 1.5rem;
  color: #000;
  font-family: Montserrat300;
  line-height: 4rem;
  margin-bottom: 10px;
}
.inputBox {
  width: 100%;
  height: 7rem;
  margin-bottom: 1rem;
}
.inputBox .titleText {
  font-family: Montserrat600;
  font-size: 1rem;
  color: #505050;
  height: 2rem;
  line-height: 2rem;
}
.inputBox .titleText > span {
  color: #da0d32;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 2rem;
}
.inputBox .inputDiv {
  width: 100%;
  height: 3rem;
  position: relative;
}
.inputBox .inputDiv .inputs {
  width: calc(100% - 10px);
  height: calc(100% - 2px);
  border: 1px solid #dbdbdb;
  padding-left: 8px;
  font-size: 1rem;
  color: #505050;
}

.inputBox .inputDiv .selectIcon {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 3rem;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
}
.inputBox .inputDiv .selectIcon > img {
  align-items: center;
  margin: auto;
}
.inputBox .inputDiv .selectInput {
  cursor: default;
}
.inputBox .inputDiv .select .options {
  background-color: #fff;
  border: 1px solid #dbdbdb;
  width: calc(100% - 18px);
  padding-left: 8px;
  padding-right: 8px;
}
.inputBox .inputDiv .select .options > li {
  height: 2.5rem;
  line-height: 2.5rem;
  cursor: default;
  border-top: 1px solid #dbdbdb;
  font-size: 1rem;
  color: #c7cacc;
}
.inputBox .inputDiv .select .options > li:first-of-type {
  border-top: 0;
}
.inputBox .inputDiv .select .options > li:hover {
  color: #505050;
}
.inputBox .inputDiv .select .options > li.act {
  color: #505050;
}

.inputBox .tipBox {
  width: 100%;
  height: 1.6rem;
  line-height: 1.6rem;
  font-size: 0.875rem;
  color: #da0d32;
}
.textAreaBox {
  width: 100%;
  height: 12rem;
}
.textAreaBox .titleText {
  font-family: Montserrat600;
  font-size: 1rem;
  color: #505050;
  height: 2rem;
  line-height: 2rem;
}
.textAreaBox .textAreaDiv {
  width: 100%;
  height: 100%;
}
.textAreaBox .textAreaDiv .textAreas {
  width: calc(100% - 12px);
  height: calc(100% - 12px);
  border: 1px solid #dbdbdb;
  padding: 5px;
  font-size: 16px;
  color: #505050;
}

.btnBox {
  width: 100%;
  height: auto;
  margin-top: 5rem;
}
.btnBox .submitBtn {
  font-size: 1rem;
  color: #fff;
  width: 7rem;
  height: 2.5rem;
  border: 0;
  border-radius: 4px;
  background-color: #083358;
  outline: none;
}
.btnBox .submitBtn:hover {
  background-color: #072c4c;
}

.hideBox {
  display: none;
}
.uline{
  /* height:1px; */
  margin-top: 10px;
  border-bottom: #4a4a4a 1px solid;
}
.privacy {
  /* border-top: #4a4a4a 1px solid; */
  margin-top: 10px;
}
</style>
